import { NgModule } from '@angular/core';
// import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTooltipModule } from '@angular/material';
import { RouterModule } from '@angular/router';

import { CommonModule } from 'common/common.module';
import { CoreModule } from 'core/core.module';
import { UserGuard } from 'core/user.guard';

import { RootComponent } from './root.component';
import { HeaderComponent } from './header/header.component';
import { AppAccessDialogComponent } from './header/app-access-dialog.component';
import { ContactUsAboutProductComponent } from './header/contact-us-about-product.component';
import { FooterComponent } from './footer/footer.component';

@NgModule({
  declarations: [
    RootComponent,
    HeaderComponent,
    AppAccessDialogComponent,
    ContactUsAboutProductComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    CoreModule,
    MatTooltipModule,
    RouterModule.forRoot([
      { path: '', pathMatch: 'full', redirectTo: 'login' },
      { path: 'login', loadChildren: './login/login.module#LoginModule' },
      { path: 'app', loadChildren: '../app/app.module#AppModule', canActivate: [UserGuard] }
    ])
  ],
  entryComponents: [AppAccessDialogComponent],
  bootstrap: [RootComponent]
})
export class RootModule { }
